// 定数を宣言

export const config = {
  imageUploadPath: '/upload/facility/',

  apiBaseUrl: '/api/1.0',

  // ページャー設定 - 1ページの表示件数
  pager: {
    perPage: 40,
    perRecommendSummary: 24,
    limit: 5,
    limitTopFacility: 12,
    limitNews: 8
  },

  // 問い合わせるボタン（fixedFooter）の表示位置（Y）
  fixedFooterPageYOffset: 100,
  // 施設を絞り込むボタン（fixedSearchFooter）の表示位置（Y）
  fixedSearchFooterPageYOffset: 140,

  // 並べ替えリスト
  orderList: [
    { value: '', name: 'おすすめ順' },
    { value: 'new', name: '新着順' },
    { value: 'name', name: '施設名順' },
    { value: 'event', name: 'イベント活用順' }
  ],

  // 画像タイプマスタ
  imageTypes: [
    { code: 1, name: 'メイン' },
    { code: 91, name: 'Place用メイン' },
    { code: 2, name: '施設外観' },
    { code: 3, name: '施設入口' },
    { code: 4, name: '施設受付（フロント）' },
    { code: 5, name: '施設フロアマップ' },
    { code: 6, name: '会議室の外' },
    { code: 7, name: '会議室の中' },
    { code: 8, name: '利用案内書（価格表）' },
    { code: 9, name: '案内ボード（スケジュール）' }
  ],

  serviceList: [
    { code: 1, name: 'tatami', label: '和室', title: '和室' },
    { code: 2, name: 'musicroom', label: '音楽室', title: '音楽室' },
    {
      code: 3,
      name: 'rehearsalroom',
      label: 'リハーサル室',
      title: 'リハーサル室'
    },
    { code: 4, name: 'greenroom', label: '控室', title: '控室' },
    { code: 5, name: 'kidsroom', label: 'キッズルーム', title: 'キッズルーム' },
    { code: 6, name: 'kitchen', label: '調理室', title: '調理室' },
    { code: 7, name: 'tyashitsu', label: '茶室', title: '茶室' },
    { code: 8, name: 'avroom', label: '視聴覚室', title: '視聴覚室' },
    { code: 9, name: 'study', label: '自習室', title: '自習室・勉強スペース' },
    { code: 101, name: 'piano', label: 'ピアノ', title: 'ピアノ' },
    { code: 102, name: 'eating', label: '飲食店', title: '飲食店' },
    { code: 103, name: 'nursingroom', label: '授乳室', title: '授乳室' },
    { code: 104, name: 'coinlocker', label: 'ロッカー', title: 'ロッカー' },
    { code: 105, name: 'copy', label: 'コピー機', title: 'コピー機' },
    { code: 106, name: 'wifi', label: '無線LAN', title: '無線LAN' },
    {
      code: 107,
      name: 'colonameasures',
      label: '感染症対策',
      title: '感染症対策'
    },
    {
      code: 108,
      name: 'panorama',
      label: '360度ビュー',
      title: '360度パノラマビュー'
    },
    { code: 109, name: 'mice', label: 'MICE施設', title: 'MICE施設の設備' },
    { code: 110, name: 'baseball', label: '野球場', title: '野球場' },
    { code: 111, name: 'soccer', label: 'サッカー場', title: 'サッカー場' },
    { code: 112, name: 'athletics', label: '陸上競技場', title: '陸上競技場' },
    { code: 113, name: 'pool', label: 'プール', title: 'プール' },
    {
      code: 114,
      name: 'basket',
      label: 'バスケットコート',
      title: 'バスケットコート'
    },
    { code: 115, name: 'tennis', label: 'テニスコート', title: 'テニスコート' },
    { code: 116, name: 'table_tennis', label: '卓球場', title: '卓球場' },
    {
      code: 117,
      name: 'planetarium',
      label: 'プラネタリウム',
      title: 'プラネタリウム'
    },
    { code: 118, name: 'library', label: '図書館', title: '図書館' }
  ],
  facilityTypeList: [
    { code: 1, label: '公共施設' },
    { code: 2, label: '貸し会議室' },
    { code: 3, label: 'コワーキングスペース' },
    { code: 4, label: '商工会議所' },
    { code: 5, label: 'ホテル' },
    { code: 6, label: '公園' },
    { code: 7, label: '体育館' },
    { code: 8, label: '競技場' },
    { code: 9, label: 'プール' },
    { code: 10, label: '動物園' },
    { code: 11, label: '水族館' },
    { code: 12, label: '植物園' },
    { code: 13, label: '博物館／科学館' },
    { code: 14, label: 'キャンプ場' },
    { code: 15, label: '道の駅' }
  ],

  infoIconList: {
    location: '住所',
    train: '最寄り駅',
    calendar: '休館日',
    tel: '電話番号',
    parking: '駐車場',
    clock: '営業時間'
  },

  // イベント規模・種類マスタ
  facilityEventTypes: [
    {
      title: '会議室',
      types: [
        {
          label: '大',
          value: 11,
          title: '大きな会議',
          searchTitle: '大人数向け会議室',
          searchSubTitle: '80人・100人以上のセミナー会場'
        },
        {
          label: '中',
          value: 12,
          title: '中規模の会議',
          searchTitle: '中規模の会議室',
          searchSubTitle: '30人〜80人までのセミナー会場'
        },
        {
          label: '小',
          value: 13,
          title: '小さな会議',
          searchTitle: '少人数向け会議室',
          searchSubTitle: '10人〜30人までのセミナー会場'
        }
      ]
    },
    {
      title: 'ホール',
      types: [
        {
          label: '大',
          value: 21,
          title: '大ホール',
          searchTitle: '大ホール',
          searchSubTitle: '800席・1000席以上の大規模向けイベント会場'
        },
        {
          label: '中',
          value: 22,
          title: '中ホール',
          searchTitle: '中ホール',
          searchSubTitle: '400席〜800席までの一般的なイベント会場'
        },
        {
          label: '小',
          value: 23,
          title: '小ホール',
          searchTitle: '小ホール',
          searchSubTitle: '100席〜400席までの小規模向けイベント会場'
        }
      ]
    },
    {
      title: 'レセプション',
      types: [
        {
          label: '有',
          value: 91,
          title: 'レセプション',
          searchTitle: 'レセプションルーム',
          searchSubTitle: 'パーティー会場や展示会などの多目的用途のイベント会場'
        }
      ]
    },
    {
      title: 'スペース',
      types: [
        {
          label: '屋外',
          value: 31,
          title: '屋外スペース',
          searchTitle: '屋外イベントスペース',
          searchSubTitle: '公園や球技場などのイベントスペース'
        },
        {
          label: '屋内',
          value: 32,
          title: '屋内スペース',
          searchTitle: '屋内イベントスペース',
          searchSubTitle: '体育館やプールなどのイベントスペース'
        }
      ]
    }
  ],

  searchArea: [
    {
      name: '北海道・東北',
      code: 1,
      prefectures: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県'
      ],
      aliasName: ['北海道', '青森', '岩手', '宮城', '秋田', '山形', '福島']
    },
    {
      name: '関東',
      code: 2,
      prefectures: [
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県'
      ],
      aliasName: ['茨城', '栃木', '群馬', '埼玉', '千葉', '東京', '神奈川']
    },
    {
      name: '中部',
      code: 3,
      prefectures: [
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県'
      ],
      aliasName: [
        '新潟',
        '富山',
        '石川',
        '福井',
        '山梨',
        '長野',
        '岐阜',
        '静岡',
        '愛知'
      ]
    },
    {
      name: '近畿',
      code: 4,
      prefectures: [
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県'
      ],
      aliasName: ['三重', '滋賀', '京都', '大阪', '兵庫', '奈良', '和歌山']
    },
    {
      name: '中国・四国',
      code: 5,
      prefectures: [
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県'
      ],
      aliasName: [
        '鳥取',
        '島根',
        '岡山',
        '広島',
        '山口',
        '徳島',
        '香川',
        '愛媛',
        '高知'
      ]
    },
    {
      name: '九州・沖縄',
      code: 6,
      prefectures: [
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県'
      ],
      aliasName: [
        '福岡',
        '佐賀',
        '長崎',
        '熊本',
        '大分',
        '宮崎',
        '鹿児島',
        '沖縄'
      ]
    }
  ],
  nearbyFacility: {
    limit: 15,
    distance: 10
  },
  nearbyEvent: {
    distance: 0.1,
    limit: 15,
    searchPageLimit: 5,
    sort: 'normal'
  },

  /**
   * 検索条件設定
   *
   * title: タイトル名,
   * eventType: イベント規模・種類を目的とする場合に、カンマ区切りで指定、例: '21,22,23'
   * service: 設備・サービスを目的とする場合に、カンマ区切りで指定、例: '6'
   * facet: 人気の場所のリストの表示対象を記載、例: 'city'
   *
   */
  searchPatternConditions: [
    {
      title: '無線LANあり',
      eventType: '',
      service: '106',
      facet: 'prefecture'
    },
    {
      title: 'ホールあり',
      eventType: '21,22,23',
      service: '',
      facet: 'prefecture'
    },
    {
      title: 'ピアノ・音楽室あり',
      eventType: '',
      service: '2,101',
      facet: 'prefecture'
    }
  ],

  /**
   * SNSアイコンリスト
   */
  snsIconUrls: [
    { name: 'instagram', url: 'https://www.instagram.com/kokuchspace/' },
    { name: 'facebook', url: 'https://www.facebook.com/kokuchspace/' },
    { name: 'twitter', url: 'https://twitter.com/kokuchspace' }
  ],

  /**
   * 感染症対策 注意情報
   */
  infectionInfoMessages: {
    capacity_limit: {
      '1': '各部屋の定員は半分程度でお願いしております。'
    },
    mask: {
      '1': '来館者の方はマスクの着用をお願いしております。',
      '2':
        '来館者の方は必ずマスクの着用をお願いいたします。マスクを着用されていない方の入場はお断りさせていただく場合がございます。'
    },
    body_temperature: {
      '1':
        '事前に体温測定を行っていただき、発熱などの症状がある方の入場はお断りさせていただく場合がございます。',
      '2':
        '来館時に体温測定を行っていただき、発熱などの症状がある方の入場はお断りさせていただく場合がございます。'
    },
    health_report: {
      '1':
        '来館者全ての方に健康状態報告書（住所・氏名・体温など）をご記入の上、提出をお願いいたします。'
    },
    participant_list: {
      '1':
        'イベント・セミナーの主催者の方には参加者の名簿の保管および管理をお願いいたします。（感染確認があった場合、後日連絡先を確認できるようにするためです）',
      '2':
        'イベント・セミナーの主催者の方には参加者の名簿の保管および管理を行っていただき、その参加者名簿の提出をお願いしております。（感染確認があった場合、後日連絡先を確認できるようにするためです）'
    },
    entrance_disinfection: {
      '1':
        '施設の入口（受付）付近にて消毒液を設置しておりますので、手指の消毒にご利用ください。'
    },
    equipment_disinfection: {
      '1': '施設内の消毒・除菌を定期的に行っております。',
      '2':
        'ご利用された箇所の消毒・除菌をお願いいたします（消毒・除菌スプレーなどは貸し出しいたします）'
    },
    ventilation: {
      '1':
        'ご利用期間中の換気を適時お願いしております。（窓・扉など換気が可能な部屋をご利用の場合のみ）'
    }
  },

  /**
   * バッジ定義 (class名: バッジ表示名称のペア)
   */
  badgeList: {
    'colona-measures': '感染症対策済み'
  }
}
